import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const services = [
  {
    slug: 'kitchen-remodeling',
    title: 'Kitchen Remodeling Connecticut',
    image: 'kitchen-remodel-marble-countertop-custom-cabinets-connecticut.jpg',
    alt: 'Kitchen remodeling contractor Connecticut - custom marble countertops wood cabinets by Visser licensed insured',
    description: 'Transform your Connecticut kitchen with our expert remodeling services. Serving Meriden, Wallingford, and shoreline communities, we specialize in custom kitchen renovations featuring modern cabinetry, granite and quartz countertops, tile backsplashes, and energy-efficient appliances.',
    features: ['Custom Kitchen Cabinets Connecticut', 'Granite & Quartz Countertop Installation CT', 'Kitchen Tile Backsplash Meriden CT', 'Kitchen Lighting Design Connecticut', 'Hardwood Flooring Installation CT'],
    cta: 'Get Free Kitchen Remodeling Quote Connecticut'
  },
  {
    slug: 'bathroom-remodeling',
    title: 'Bathroom Remodeling Connecticut',
    image: 'modern-bathroom-marble-tile-walk-in-shower-connecticut.jpg',
    alt: 'Bathroom renovation contractor Connecticut - marble tile walk-in shower modern vanity by Visser licensed insured',
    description: 'Expert bathroom renovation services throughout Connecticut. Our bathroom remodeling contractors serve Meriden, Old Saybrook, Madison, Guilford, and Connecticut shoreline areas. We specialize in custom tile work, modern vanities, walk-in showers, and complete bathroom transformations.',
    features: ['Custom Bathroom Tile Work Connecticut', 'Bathroom Vanity Installation Meriden CT', 'Walk-in Shower Installation Connecticut', 'Modern Bathroom Fixture Upgrades CT', 'Accessible Bathroom Modifications Connecticut'],
    cta: 'Request Bathroom Remodeling Estimate CT'
  },
  {
    slug: 'deck-building',
    title: 'Trex Deck Builder Connecticut',
    image: 'composite-deck-white-railing-connecticut-home-remodeling.jpg',
    alt: 'Trex composite deck installation Connecticut - white railing outdoor living by licensed insured contractor',
    description: 'Professional Trex composite deck installation throughout Connecticut. Our deck builders serve Meriden, Wallingford, Old Saybrook, Madison, and CT shoreline communities. We specialize in low-maintenance Trex decking, custom deck designs, railing systems, and outdoor living spaces.',
    features: ['Trex Composite Decking Installation Connecticut', 'Custom Deck Design Meriden CT', 'Deck Railing Systems Connecticut', 'Built-In Deck Seating CT', 'Pergola Construction Connecticut'],
    cta: 'Get Deck Building Quote Connecticut'
  },
  {
    slug: 'basement-finishing',
    title: 'Basement Finishing Connecticut',
    image: 'basement-finishing-renovation-living-space-connecticut.jpg',
    alt: 'Basement finishing contractor Connecticut - professional renovation living space by Visser licensed insured',
    description: 'Transform your Connecticut basement into valuable living space. Our basement finishing contractors serve Meriden, Wallingford, Cheshire, Hamden, and surrounding CT areas. We specialize in basement remodeling, waterproofing, framing, drywall, flooring, and custom built-ins.',
    features: ['Basement Framing & Drywall Connecticut', 'Basement Flooring Installation Meriden CT', 'Basement Lighting & Electrical CT', 'Basement Waterproofing Connecticut', 'Custom Basement Built-Ins CT'],
    cta: 'Request Basement Finishing Estimate CT'
  },
  {
    slug: 'vinyl-siding',
    title: 'Vinyl Siding Installation Connecticut',
    image: 'vinyl-siding-red-exterior-connecticut-home.jpg',
    alt: 'Vinyl siding installation contractor Connecticut - energy efficient exterior home improvement licensed',
    description: 'Energy-efficient vinyl siding installation throughout Connecticut. Enhance your home\'s curb appeal and protection with professional siding services in Meriden, Wallingford, and shoreline areas.',
    features: ['Vinyl Siding Installation CT', 'Trim & Soffit Work', 'Insulation Upgrades Connecticut', 'Color Consultation', 'Fascia Repair CT'],
    cta: 'Get Vinyl Siding Quote CT'
  },
  {
    slug: 'window-replacement',
    title: 'Window Replacement Connecticut',
    image: 'window-trim-installation-connecticut-contractor.jpg',
    alt: 'Window replacement contractor Connecticut - energy efficient windows professional installation licensed',
    description: 'Professional window replacement services in Meriden, Wallingford, and Connecticut shoreline areas. We install energy-efficient windows in custom sizes with expert trim work.',
    features: ['Energy-Efficient Windows CT', 'Custom Window Sizes', 'Professional Installation Connecticut', 'Interior & Exterior Trim CT', 'Bay & Bow Windows'],
    cta: 'Get Window Replacement Quote CT'
  },
  {
    slug: 'custom-furniture',
    title: 'Custom Furniture & Aquariums Connecticut',
    image: 'custom-handcrafted-wooden-table-furniture-connecticut-artisan.jpg',
    alt: 'Custom furniture and aquarium installations Connecticut - handcrafted tables shelving built-in fish tanks by licensed contractor',
    description: 'Handcrafted custom furniture, built-in cabinetry, and unique custom aquarium installations for Connecticut homes. From hardwood tables and shelving to stunning built-in fish tanks, we bring your ideas to life.',
    features: ['Custom Furniture Design CT', 'Built-In Aquariums & Fish Tanks', 'Quality Hardwood Materials', 'Built-In Cabinetry Connecticut', 'Tables, Desks & Shelving CT'],
    cta: 'Get Custom Furniture Quote CT'
  },
  {
    slug: 'home-maintenance',
    title: 'Home Maintenance Services Connecticut',
    image: 'general-home-maintenance-connecticut-handyman-services.jpg',
    alt: 'Home maintenance repair services Connecticut - painting drywall handyman by licensed insured contractor',
    description: 'Comprehensive home maintenance and repair services throughout Connecticut. From painting to drywall repair, door installation, and seasonal maintenance for Meriden and CT homeowners.',
    features: ['General Home Repairs CT', 'Interior & Exterior Painting Connecticut', 'Drywall Repair Meriden CT', 'Door & Trim Work', 'Seasonal Maintenance CT'],
    cta: 'Get Home Maintenance Quote CT'
  },
];

const CheckIcon = () => (
  <svg className="w-5 h-5 text-[#3a87fe] mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
  </svg>
);

const ServicesPage = () => {
  const seoData = {
    title: 'Home Remodeling Services Connecticut | Kitchen, Bathroom, Deck, Basement CT | Visser',
    description: 'Professional home remodeling services in Connecticut. Kitchen remodeling, bathroom renovation, Trex decking, basement finishing, vinyl siding, window replacement. Serving Meriden, Wallingford, Old Saybrook, Madison & CT shoreline.',
    keywords: 'home remodeling services Connecticut, CT kitchen remodeling, bathroom renovation CT, deck building Connecticut, basement finishing CT, vinyl siding, window replacement, Meriden contractor',
    canonical: 'https://cthomeremodels.com/services',
    ogImage: 'https://cthomeremodels.com/og/v2/services.png'
  };

  return (
    <div className="services-page">
      <SEO {...seoData} />

      {/* Hero */}
      <section
        className="relative py-32 md:py-40 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)), url('/api/media/name/deck-stairs-composite-construction-connecticut.jpg')`
        }}
        data-testid="services-hero"
      >
        <div className="absolute top-6 left-6 z-10">
          <img
            src="/api/media/name/visser-general-construction-llc-logo-connecticut.png"
            alt="Visser General Construction LLC Logo - Licensed and Insured CT Home Remodeling Services"
            className="h-20 md:h-28 object-contain drop-shadow-2xl"
          />
        </div>
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white drop-shadow-lg">
            Professional Home Remodeling Services in Connecticut
          </h1>
          <p className="text-base md:text-lg max-w-4xl mx-auto text-white drop-shadow-md">
            Expert kitchen renovations, bathroom remodeling, deck building, and basement finishing throughout Meriden, Old Saybrook, Madison, Guilford, and Connecticut shoreline communities
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-4xl text-center">
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            Visser General Construction LLC specializes in comprehensive home remodeling services across Connecticut. Our experienced team serves homeowners in Meriden, Wallingford, Southington, Cheshire, Hamden, Old Saybrook, Westbrook, Madison, Guilford, Branford, and surrounding CT areas.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {services.map((service) => (
              <div key={service.slug} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300" data-testid={`service-card-${service.slug}`}>
                {/* Service Image */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={`/api/media/name/${service.image}`}
                    alt={service.alt}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <h2 className="absolute bottom-4 left-6 right-6 text-2xl font-bold text-white drop-shadow-lg">
                    {service.title}
                  </h2>
                </div>

                {/* Service Content */}
                <div className="p-6">
                  <p className="text-gray-700 mb-4 leading-relaxed">{service.description}</p>
                  <div className="border-t border-gray-200 pt-4 mb-4">
                    <ul className="space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start gap-2">
                          <CheckIcon />
                          <span className="text-sm text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* CTA Link */}
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                  <Link to={`/services/${service.slug}`} className="text-[#3a87fe] font-semibold hover:underline" data-testid={`service-link-${service.slug}`}>
                    {service.cta} →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Area */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 text-center max-w-4xl">
          <h2 className="text-3xl font-bold mb-6">Serving Connecticut Homeowners</h2>
          <p className="text-base md:text-lg text-gray-700 mb-8 leading-relaxed">
            Visser General Construction provides professional home remodeling services throughout Connecticut, including Meriden, Wallingford, Southington, Cheshire, Hamden, Colchester, Middlefield, East Haddam, Old Saybrook, Westbrook, Madison, Guilford, Branford, Deep River, Middletown, Clinton, Chester, and surrounding Connecticut communities within 40 miles of Meriden.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#5c0701] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6">Ready to Start Your Connecticut Home Remodeling Project?</h2>
          <p className="text-base md:text-lg mb-8 max-w-2xl mx-auto">
            Contact our Connecticut home remodeling contractors today for a free consultation and detailed estimate
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="bg-[#3a87fe] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#2968d9] transition" data-testid="services-cta-contact">
              Get Free Estimate
            </Link>
            <a href="tel:2036043202" className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-[#5c0701] transition" data-testid="services-cta-call">
              Call (203) 604-3202
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
